import React from 'react';
import styles from './Spinner.module.scss';

const Spinner: React.FC = () => {
	return <div className={styles.spin}></div>;
};
export default Spinner;
